import { render } from "./index_use_no_paye.vue?vue&type=template&id=0cbdaec0"
import script from "./index_use_no_paye.vue?vue&type=script&lang=js"
export * from "./index_use_no_paye.vue?vue&type=script&lang=js"

import "./index_use_no_paye.vue?vue&type=style&index=0&id=0cbdaec0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__